import { render, staticRenderFns } from "./select1.vue?vue&type=template&id=025d1b2a"
import script from "./select1.vue?vue&type=script&lang=js"
export * from "./select1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports